export const listMonth = [
    {
        key: 1,
        text: 'January'
    },
    {
        key: 2,
        text: 'February'
    },
    {
        key: 3,
        text: 'March'
    },
    {
        key: 4,
        text: 'April'
    },
    {
        key: 5,
        text: 'May'
    },
    {
        key: 6,
        text: 'June'
    },
    {
        key: 7,
        text: 'July'
    },
    {
        key: 8,
        text: 'August'
    },
    {
        key: 9,
        text: 'September'
    },
    {
        key: 10,
        text: 'October'
    },
    {
        key: 11,
        text: 'November'
    },
    {
        key: 12,
        text: 'December'
    },
]